export enum ImportType {
  FUNCTIONS = 'functions',
  SUPPLIERS = 'suppliers',
  IT_SYSTEMS = 'it_systems'
}

export interface CSVImportRequest {
  bcp_id: number;
  import_type: ImportType;
  csv_data: string; // Base64 encoded CSV content
}

export interface CSVValidationError {
  row: number;
  field: string;
  value: string;
  error: string;
}

export interface CSVImportResponse {
  success: boolean;
  message: string;
  imported_count: number;
  errors: CSVValidationError[];
  warnings: string[];
}

export interface CSVTemplate {
  import_type: ImportType;
  headers: string[];
  sample_data: Record<string, string>[];
  description: string;
  required_fields: string[];
  optional_fields: string[];
}

export interface CSVTemplateResponse {
  import_type: string;
  csv_content: string; // Base64 encoded
  filename: string;
  mime_type: string;
}

export interface CSVTemplatesResponse {
  templates: CSVTemplate[];
}
